// Fonction pour détecter les caractères non imprimables
export const noInvisibleChars = (value?: string): boolean => {
  if (!value) return false;
  return !/[\x00-\x1F\x7F\u200B-\u200D\u2028\u2029\u2060\uFEFF]/.test(value);
};